import React, { useEffect, useRef } from "react";

export default function Rooms() {
  const widgetRef = useRef(null);

  useEffect(() => {
    const widget = widgetRef.current;
    if (widget) {
      widget.innerHTML = `
        <div id="TA_rated82" class="TA_rated">
          <ul id="FeHv1sWd5" class="TA_links a5YncdhrU">
            <li id="EgbuM2kIUNTh" class="Ajw5y3VPzgeu">
              <a target="_blank" rel="noopener noreferrer"
                 href="https://www.tripadvisor.com.mx/Hotel_Review-g3179456-d33309253-Reviews-Hotel_La_Finca_Por_Zotoluca-Apan_Central_Mexico_and_Gulf_Coast.html">
                <img src="https://www.tripadvisor.com.mx/img/cdsi/img2/badges/ollie-11424-2.gif" alt="TripAdvisor"/>
              </a>
            </li>
          </ul>
        </div>
      `;
      const script = document.createElement("script");
      script.async = true;
      script.src =
        "https://www.jscache.com/wejs?wtype=rated&uniq=82&locationId=33309253&lang=es_MX&display_version=2";
      script.setAttribute("data-loadtrk", "");
      script.onload = function () {
        // @ts-ignore
        this.loadtrk = true;
      };
      widget.appendChild(script);
    }
    return () => {
      if (widget) widget.innerHTML = "";
    };
  }, []);

  return (
    <section id="reviews">
      <style>{`
        #reviews {
          padding-top: 40px;
          padding-bottom: 100px;
        }
        .ta-wrap {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .TA_rated img {
          max-width: 240px;
          height: auto;
          display: block;
          margin: 0 auto;
        }
        .ta-cta {
          margin-top: 16px;
          text-align: center;
        }
        .ta-button {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 18px;
          border-radius: 999px;
          background: #00a680 !important;
          color: #fff !important;
          text-decoration: none !important;
          font-weight: 600;
          transition: transform .15s ease, box-shadow .15s ease, opacity .15s ease;
        }
        .ta-button:hover {
          background: #00936f !important;
          transform: translateY(-1px);
          box-shadow: 0 6px 18px rgba(0,166,128,0.25);
          opacity: .95;
        }
        .ta-button img {
          height: 18px;
          width: auto;
          display: block;
        }
      `}</style>

      <div className="container">
        <div className="ta-wrap">
          <div>
            {/* <div ref={widgetRef} /> */}
            <div className="ta-cta">
              <a
                className="ta-button"
                href="https://www.tripadvisor.com.mx/Hotel_Review-g3179456-d33309253-Reviews-Hotel_La_Finca_Por_Zotoluca-Apan_Central_Mexico_and_Gulf_Coast.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://static.tacdn.com/img2/brand_refresh/Tripadvisor_logomark.svg"
                  alt="Tripadvisor"
                />
                Ver reseñas en TripAdvisor
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
